var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"logo"},[_c('LogoFinerFoodsBranca')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }